module.exports = __webpack_public_path__ + "img/1575266778.1f47913b.jpg";